// extracted by mini-css-extract-plugin
export default {"container":"Information_container__oCGPV","break":"Information_break__9MlxU","image":"Information_image__txZpK"};